import React from 'react';
import { Phone, Mail, Clock, Plus, Pencil, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';

export function ContactsSection({ contacts, onAdd, onEdit, onDelete }) {
    return (
        <div className="space-y-6" data-testid="welcome-contacts">
            <div className="flex justify-between items-center">
                <div>
                    <h2 className="text-2xl font-bold">Key Contacts</h2>
                    <p className="text-muted-foreground text-sm mt-1">
                        Important contact numbers and departments for residents
                    </p>
                </div>
                <Button onClick={onAdd} className="bg-teal-600 hover:bg-teal-700" data-testid="add-contact-btn">
                    <Plus className="w-4 h-4 mr-2" />
                    Add Contact
                </Button>
            </div>

            <div className="space-y-3">
                {contacts.map((contact) => (
                    <div key={contact.id} className="card-base" data-testid={`contact-card-${contact.id}`}>
                        <div className="flex items-start gap-4">
                            <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                                <Phone className="w-6 h-6 text-blue-600" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <h3 className="font-semibold">{contact.role}</h3>
                                <p className="text-sm text-muted-foreground">{contact.description}</p>
                                <div className="flex flex-wrap gap-4 mt-2 text-sm">
                                    {contact.phone && (
                                        <span className="flex items-center gap-1 text-blue-600">
                                            <Phone className="w-3 h-3" /> {contact.phone}
                                        </span>
                                    )}
                                    {contact.email && (
                                        <span className="flex items-center gap-1 text-blue-600">
                                            <Mail className="w-3 h-3" /> {contact.email}
                                        </span>
                                    )}
                                    {contact.availability && (
                                        <span className="flex items-center gap-1 text-muted-foreground">
                                            <Clock className="w-3 h-3" /> {contact.availability}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="flex items-center gap-2">
                                <Button variant="ghost" size="sm" onClick={() => onEdit(contact)} data-testid={`edit-contact-${contact.id}`}>
                                    <Pencil className="w-4 h-4" />
                                </Button>
                                <Button variant="ghost" size="sm" className="text-red-600 hover:text-red-700 hover:bg-red-50" onClick={() => onDelete(contact)} data-testid={`delete-contact-${contact.id}`}>
                                    <Trash2 className="w-4 h-4" />
                                </Button>
                            </div>
                        </div>
                    </div>
                ))}
                {contacts.length === 0 && (
                    <div className="text-center py-12 text-muted-foreground">
                        <Phone className="w-12 h-12 mx-auto mb-3 opacity-50" />
                        <p>No contacts configured. Default contacts will be shown.</p>
                        <Button onClick={onAdd} className="mt-4" variant="outline">
                            <Plus className="w-4 h-4 mr-2" />
                            Add Your First Contact
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ContactsSection;
